import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";

export class DeleteCurrentPartner {
	constructor(private repository: PartnerSocketRepository) {}

	execute(params: DeleteCurrentPartnerParams): Promise<void> {
		return this.repository.deleteCurrentPartner(params.user_id);
	}
}

export class DeleteCurrentPartnerParams {
	constructor(public user_id: string) {}
}
